import { get, put, post } from "../httpmethods";
import { URL_API } from "../config";


export const WhatsappAPI = {
    getWhatsapp: async () => {
        return await get(`${URL_API}/whatsapp/qrcode`);
    },
}
